export function processError(error) {
    // Sem response = network error / backend offline. O ConnectionBanner
    // já sinaliza a queda no topo da tela — toasts adicionais viram ruído.
    // Retorna '' (falsy) pra que o Toast e o ActionMessage não mostrem nada.
    if (!error || !error.response) {
        console.error('Network error:', error && error.message);
        return '';
    }
    // Redirect em 401/403 é responsabilidade do interceptor centralizado
    // em BaseService.js — aqui só passa a mensagem do backend pra UI.
    const errorMessage = error.response.data;
    console.error(errorMessage);
    return errorMessage;
}

export function getAuthHeaders(token) {
    const headers = { 'authorization': token };
    return { headers };    
}

export function getBaseUrl(path) {
    let apiUrl = process.env.REACT_APP_API_URL;
    if (path)
        apiUrl = `${apiUrl}${path}`; 
    return apiUrl;
}
